const a=()=>(null===navigator||void 0===navigator?void 0:navigator.languages)||[];export{a as navigatorDetector};
